export const PositionCategories = {
  0: { label: 'Specialists', key: 'specialists' },
  1: { label: 'Managers', key: 'top' },
  2: { label: 'Management', key: 'management' },
  3: { label: 'TechnicalStaff', key: 'technical' },
};

export const UPLOAD_FILE_TYPE = {
  AVATAR: 0,
  BANNER: 1,
  CHAT: 2,
  TICKET_ATTACHMENT: 3,
  CONTRACT: 4,
  TEMPLATE: 5,
  ARTICLE: 6,
  EVENT_FILE: 7,
  RESOURCE_FILE: 8,
  SKILL_IMAGE: 9,
  PRESENTATION: 10,
  INTERNAL_DOCUMENT: 11,
  MY_DRIVE: 12,
};

export const APPOINTMENT_STATUSES = [
  { label: 'New', value: '1' },
  { label: 'InReview', value: '2' },
  { label: 'Approved', value: '3' },
  { label: 'StatusRejected', value: '4' },
  { label: 'Pending', value: '5' },
];

export const APPLICATION_STATUSES = {
  Created: 0,
  InProgressSigned: 1,
  InProgressNotSigned: 2,
  Rejected: 3,
  Archive: 4,
  ForExecution: 5,
  Completed: 6,
};

export const TEMPLATE_STATUSES = {
  0: { label: 'New', color: 'black', darkThemeColor: 'white' },
  1: { label: 'Rejected_male', color: 'red', darkThemeColor: 'red' },
  2: { label: 'Verified', color: 'green', darkThemeColor: 'green' },
};

export const SKUD_VIOLATION_TYPES = [
  { label: 'Lateness', value: 1 },
  { label: 'EarlyLeaving', value: 2 },
  { label: 'AbsenceOnWork', value: 4 },
];

export const DOCUMENT_APPROVER_STATUSES = {
  Pending: 0,
  Reviewed: 1,
  Signed: 2,
  Rejected: 3,
  Approved: 6,
};
